const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true
		},
		buttonContext: 'mailing',
		renderEmptyBeforReady: true,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'nl_mailings',
		rowActionsProperties: {
			colWidth: '315px',
			colSpan: 1,
			rowSpan: 2
		},
		customColActionsFile: 'templates/newsletter/mailings/table/customColActions',
		// rowActions: {
		// 	delete: true,
		// 	edit: true,
		// 	customs: [{
		// 		buttonType: 'showDuplicate',
		// 		buttonContext: 'mailing'
		// 	}]
		// },
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'mailingID',
				direction: 'desc'
			}]
		}
	},

	events: {
		hoverIn: {
			type: 'mouseenter',
			selector: 'tbody',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('tbody');
				var rowID = $target.data('rowId');
				if(rowID){
					var mailingResourceData = self.getRowData(rowID);
					if(mailingResourceData && self.model.controller){
						self.model.controller.triggerFind('update', {
							mailingResourceData: mailingResourceData
						}, 'templates_newsletter_mailings_simpleStatCharts')
					}
				}
			}
		}
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
			if(areBaseTableResourceFilters === false && actionKey === 'loadFirstPreviewSubscriber' && this.model.showPreviewMailingID){
				resourceFilters.mailingID = this.model.showPreviewMailingID;
				resourceFilters.limit = 1;
			}
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			const nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 4;
		},

		sanitizeEntity: function(refEntity){
			refEntity.additionalClasses = [];
			if((refEntity.attributes || {}).parentMailingID){
				refEntity.additionalClasses.push('isChildMailing');
			}
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			this.performAndStoreAction(
				'showInsert_mailing_inEffect',
				this.prepareAction('showInsert_mailing')
			);
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID && this.model.controller) {
				var mailingAttributes = (rowData || {}).attributes || {};

				if(mailingAttributes.sendStatus === 'draft'){
					this.model.controller.performAndStoreAction(
						'showEdit_mailing_inEffect_' + rowID,
						this.model.controller.prepareAction('showEdit_mailing', undefined, {
							mailingForm: {
								resourceID: rowID
							},
							preview: {
								routePath: mailingAttributes.routePath,
								mailingID: rowID
							},
							segments: {
								mailingID:				rowID,
								statsRecipients:		mailingAttributes.statsRecipients
							},
							routeTreeParent: {
								resourceID: mailingAttributes.routeID,
								type: 'newsletter'
							},
							tabOptions: {
								title: mailingAttributes.subject + ': #' + rowID,
								icon: 'fi fi-envelope'
							}
						})
					);
				} else {
					this.model.controller.performAndStoreAction(
						'showEdit_sentMailing_inEffect_' + rowID,
						this.model.controller.prepareAction('showEdit_sentMailing', undefined, {
							mailingForm: {
								resourceID: rowID
							},
							preview: {
								routePath: mailingAttributes.routePath,
								mailingID: rowID
							},
							stats: {
								mailingID: rowID
							},
							mailingUrls: {
								mailingID: rowID
							},
							subscriberSpecifics: {
								mailingID: rowID,
								postProcessingOptions: {
									isPostProcessing: true
								}
							},
							// segments: {
							// 	mailingID:				rowID,
							// 	statsRecipients:		mailingAttributes.statsRecipients
							// },
							// routeTreeParent: {
							// 	resourceID: mailingAttributes.routeID
							// },
							tabOptions: {
								title: mailingAttributes.subject + ': #' + rowID,
								icon: 'fi fi-envelope'
							}
						})
					);

				}
			}
		},

		showDuplicate: function(rowID, rowData, buttonMode){
			if(rowID){
				return this.performAndStoreAction(
					'showDuplicate_mailing_inEffect',
					this.prepareAction('showDuplicate_mailing', rowID),
					true
				);
			}

			return utils.promise.reject(new Error('SHOW DUPLICATE MAILING MISSING MAILING_ID'));
		},

		showPreview: function(rowID, rowData, buttonMode){
			var self = this;
			if (rowID > 0) {
				self.model.showPreviewMailingID = rowID;
				self.performAndStoreAction(
					'loadFirstPreviewSubscriber_inEffect',
					self.prepareAction('loadFirstPreviewSubscriber'),
					true
				).then(function(context){
					var subscriberID = ((((((context || {}).action || {}).response || {}).data || [])[0] || {}).attributes || {}).subscriberID || 0;
					// subscriber for preview found
					if (subscriberID > 0) {
						// call action
						self.performAction(
							self.prepareAction('getMailingPreviewURL', undefined, undefined, {
								source: {
									submit: {
										data: {
											data: {
												attributes: {
													subscriberID:			subscriberID,
													mailingID: 				rowID,
													viewMode: 				'html',
													generateAndReturnURL: 	true
												}
											}
										}
									}
								}
							})
						).then(function(context){
							if(((((context || {}).response || {}).data || {}).attributes || {}).url){
								window.open(context.response.data.attributes.url);
							} else {
								alert('Beim Öffnen der Vorschau ist ein Fehler aufgetreten!');
							}
						});
					} else {
						alert('Es wurden noch keine Vorschau-Empfänger definiert!');
					}
				});
			}
		},

		resend: function(rowID, rowData, buttonMode){
			if(rowID){
				var self = this;
				return self.performAndStoreAction(
					'resend_mailing_inEffect',
					self.prepareAction('resend_mailing', rowID),
					true
				).then(function(){
					return self.refreshData(true);
				});
			}

			return utils.promise.reject(new Error('RESEND MAILING MISSING MAILING_ID'));
		},

		delete: function(rowID, rowData, buttonMode){
			if(rowID){
				var self = this;
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.mailing.title'),
						message:    storage.__('hint.delete.really.mailing.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {

						return self.performAction(
							self.prepareAction('deleteMailing', rowID)
						).then(function(context){
							// refresh list of mailings
							self.refreshData(true);
							return context;
						});
					}

					return utils.promise.reject();
				});
			}

			return utils.promise.reject(new Error('DELETE MAILING MISSING MAILING_ID'));
		},

		schedule: function(rowID, rowData, buttonMode){
			if(rowID){
				var self = this
				var ts = ((rowData || {}).attributes || {}).sendDateTime || ''
				var now = utils.moment()
				var diff = utils.moment(ts).diff(now)

				// show hint for sending mailings immediately due to sendDateTime being in the past.
				if(diff < 0){
					return self.performDecision(
						'confirm',
						{
							component:  self,
							title:      storage.__('mailing.hint.schedule.sendDateTimeInPast.title'),
							message:    storage.__('mailing.hint.schedule.sendDateTimeInPast.message'),
						}
					).then(function(context) {
						if (context.decision.type === 'yes') {
							self.changeMailingStatus(rowID, 'schedule');
						}
					})
				} else {
					self.changeMailingStatus(rowID, 'schedule');
				}
			}

			return utils.promise.reject(new Error('SCHEDULE MAILING MISSING MAILING_ID'));
		},
		unschedule: function(rowID, rowData, buttonMode){
			if(rowID){
				this.changeMailingStatus(rowID, 'unschedule');
			}

			return utils.promise.reject(new Error('UNSCHEDULE MAILING MISSING MAILING_ID'));
		},
		abort: function(rowID, rowData, buttonMode){
			if(rowID){
				this.changeMailingStatus(rowID, 'abort');
			}

			return utils.promise.reject(new Error('ABORT MAILING MISSING MAILING_ID'));
		},

		changeMailingStatus: function(mailingID, action){
			var self = this;
			return self.performAction(
				self.prepareAction('changeMailingStatus', undefined, undefined, {
					source: {
						submit: {
							data: {
								data: {
									attributes: {
										mailingID:	mailingID,
										action:		action
									}
								}
							}
						}
					}
				})
			).then(function(context){
				self.refreshData(true);
			});
		},
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_newsletter_mailings_controller', function(controller){
					self.model.controller = controller
				});
			}
		},

		async onDecision($element, options){
			var self = this;
			if(options.decisionComponent.hasClass('base_modal_modal')){
				if(options.decisionType === 'cancel'){
					options.decisionComponent.hide();
				} else if(options.decisionComponent.hasClass('container_templates_propertiesForms_newMailingPropertiesForm')){
					let propertiesForm
					options.decisionComponent.find('templates_propertiesForms_newMailingPropertiesForm', c => propertiesForm = c)

					if(propertiesForm){
						const context = await propertiesForm.save()
						await options.decisionComponent.hide()

						const newMailingData = ((context ||{}).response || {}).data || {}
						const newMailingAttributes = newMailingData.attributes || {}
						const mailingID = newMailingAttributes.id || newMailingAttributes.mailingID
						if(mailingID){
							self.showEdit(mailingID, newMailingData)
						}
						self.refresh()
					}
				} else if(options.decisionComponent.hasClass('container_templates_newsletter_mailings_edit_properties_properties')){
					let propertiesForm
					options.decisionComponent.find('templates_newsletter_mailings_edit_properties_properties', c => propertiesForm = c)

					if(propertiesForm){
						const context = await propertiesForm.submit()
						await options.decisionComponent.hide()

						const newMailingData = ((context ||{}).response || {}).data || {}
						const newMailingAttributes = newMailingData.attributes || {}
						const mailingID = newMailingAttributes.id || newMailingAttributes.mailingID
						if(mailingID){
							self.showEdit(mailingID, newMailingData)
						}
					}
				}
			}
		}
	},

	handlers: [
		{
			name: 'onSubmitDone',
			componentClass: 'templates_newsletter_mailings_edit_properties_properties',
			handle: function(callerComponent, nodeData, insertPerformed){
				this.refreshData(true);
			}
		},
		{
			name: 'refreshAfterMailingSegmentsChange',
			handle: function(callerComponent, nodeData, insertPerformed){
				this.refreshData(true);
			}
		}
	]
}
